export enum LogsActionsServiceName {
  MsOutgoing = 'MsOutgoing',
  MsMessagerie = 'MsMessagerie',
  MsAcademic = 'MsAcademic',
}
